import _ from "underscore";

import Backbone from "pages/common/lib/backbone-helpers";

var DVRGapsCollection = Backbone.Collection.extend({
    url: function () {
        var queryParam = {
            action: `query`,
            app: `grabyo-studio-prod`,
            streamName: this.stream.getDvrStoreName(),
            forceLoad: true,
            responseType: `JSON`
        };
        var dvrStreamQueryURL = this.stream.getDvrStreamQueryURL();

        return `${dvrStreamQueryURL}?${$.param(queryParam)}`;
    },

    initialize: function (models, options) {
        options = _.isObject(options) ? options : {};
        if (!_.isUndefined(options.stream)) {
            this.stream = options.stream;
        } else {
            // throw("DVRGapsCollection requires `stream`");
        }
    },

    parse: function (response) {
        if (_.isUndefined(response) || Object.keys(response).length === 0) {
            return [];
        }

        var dataKey = Object.keys(response)[0];

        var data = response[dataKey];

        var gaps = [];

        var utcStart = data.utcStart;

        data.blocks.forEach(function (block, index, arr) {
            if (index === 0) {
                if (utcStart !== block.utcStart) {
                    gaps.push({
                        start: utcStart,
                        end: block.utcStart,
                        duration: block.utcStart - utcStart
                    });
                }
            } else {
                var lastBlock = arr[index - 1];

                gaps.push({
                    start: lastBlock.utcEnd,
                    end: block.utcStart,
                    duration: block.utcStart - lastBlock.utcEnd
                });
            }
        });

        return gaps;
    },

    getSyncOffset: function (time, startTime) {
        time = _.isNumber(time) ? time : new Date().getTime();
        return this.filter(function (gap) {
            return gap.get(`end`) >= startTime && gap.get(`start`) <= time;
        }).reduce(function (offset, gap) {
            var gapDuration =
                time > gap.get(`end`)
                    ? gap.get(`duration`)
                    : time - gap.get(`start`);
            return offset + gapDuration;
        }, 0);
    },

    getGapLengthBetween: function (start, end) {
        return this.filter(function (gap) {
            return gap.get(`start`) <= end && gap.get(`end`) >= start;
        }).reduce(function (memo, gap) {
            var currentGapDuration = 0;
            if (gap.get(`end`) < end) {
                currentGapDuration = gap.get(`duration`);
            } else {
                currentGapDuration = end - gap.get(`start`);
            }
            return memo + currentGapDuration;
        }, 0);
    },

    isTimeInGap: function (timestamp) {
        return !_.isUndefined(this.getGapForTime(timestamp));
    },

    getGapForTime: function (timestamp) {
        return this.filter(function (gap) {
            return timestamp >= gap.get(`start`) && timestamp <= gap.get(`end`);
        })[0];
    }
});

export default DVRGapsCollection;
